/** 
 * @Author   yt.nie
 * @Github   https://github.com/yutang8215
 * @DateTime 2018-06-25
 * @Description [路由拦截封装]
 */
import Vue from 'vue'
import Router from 'vue-router'
import RouterCommon from './common' // 引入路由模块

import { Notification } from 'element-ui'
import { Local, Session, Cookie, setTitle } from '@/assets/js/utils'
import { title, entryTypeKey, authIdKey, apiTokenKey, travelApiTokenKey, devTestToken } from '@/config'

Vue.use(Router)

// vue-router ≥3.0版本回调形式以及改成promise api的形式了，返回的是一个promise，如果没有捕获到错误，控制台始终会出现警告，
const routeTypes = ['push', 'replace']
for (let me of routeTypes) {
  const original = Router.prototype[me]
  Router.prototype[me] = function(location) {
    return original.call(this, location).catch(err => err)
  }
}

function showToast(options) {
  const DEFAULT = { type: 'success', title: '提示', duration: 1500, offset: 100 };
  Notification({ ...DEFAULT, ...options });
}

const router = new Router({
  mode: 'history',
  base: '/w/', //url前缀// 两边斜杠要加（history模式用）
  routes: [
    ...RouterCommon,
  ],
  scrollBehavior(to, from, savedPosition) {
    //history模式时生效
    if (savedPosition) {
      return savedPosition
    } else {
      // 异步滚动操作
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            x: 0,
            y: 0
          });
        }, 0);
      });
    }
  }
});

/**
 * @页面切换取消上次请求
 */
const cancelLastReq = (callback) => {
  let axiosPromiseArr = window.__axiosPromiseArr || [];
  if (!!axiosPromiseArr && axiosPromiseArr.length) {
    let len = axiosPromiseArr.length;
    while (len--) {
      axiosPromiseArr[len].cancel("cancel");
      axiosPromiseArr.splice(len, 1);
    }
  }
  'function' === typeof callback && callback()
}

const isLogin = (to, from, next) => {

  cancelLastReq(() => {
    /**
     * 访问类型参数（默认散客）
     * 1个人，2团体，3旅行社
     */
    const path = to.path;
    if (path.indexOf('home') != -1) {
      Session.set(entryTypeKey, 1);
    } else if (path.indexOf('person') != -1) {
      Session.set(entryTypeKey, 1);
    } else if (path.indexOf('team') != -1) {
      Session.set(entryTypeKey, 2);
    } else if (path.indexOf('travel') != -1) {
      Session.set(entryTypeKey, 3);
    }

    // console.log('入口类型===', Session.get(entryTypeKey))

    const entryType = Session.get(entryTypeKey)
    
    /**
     * @散客、普通团体扫码登录获取token及openid
     */
    if ([1, 2].includes(+entryType)) {
      if (!Local.get(apiTokenKey)) {
        const cookieOpenid = Cookie.get('bjbwy_openid') || ''; //支付用
        const cookieApiToken = Cookie.get('bjbwy_api_token') || '';
        cookieOpenid && Local.set(authIdKey, cookieOpenid);
        cookieApiToken && Local.set(apiTokenKey, cookieApiToken);
      }
    }
    /**
     * 验证登录
     */
    if (to.meta.auth) {
      if ([1, 2].includes(+entryType)) {
        if (!Local.get(apiTokenKey)) {
          // 强制首页
          next({
            path: '/',
            replace: true //为true时不可自行回退
          })
        } else {
          next()
        }
      } else if (entryType == 3) {
        if (!Local.get(travelApiTokenKey)) {
          // 强制首页
          next({
            path: '/',
            replace: true //为true时不可自行回退
          })
        } else {
          next()
        }
      }
    } else {
      // 无需验证
      next()
    }
  })
}

router.beforeEach((to, from, next) => {
  // 测试用
  !!devTestToken && Local.set(apiTokenKey, devTestToken)
  isLogin(to, from, next)
})

router.afterEach((to, from) => {
  const resTitle = setTitle(to, title)
  window.document.title = resTitle
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js